import Fuse from 'fuse.js'
import compactArrayUtil from '../../array/compact'

const defaultOptions = {
  shouldSort: true,
  includeScore: false,
  includeMatches: false,
  isCaseSensitive: false,
  findAllMatches: false,
  threshold: 0.3,
  location: 0,
  distance: 100,
  minMatchCharLength: 1,
  keys: [
    'name',
    'data.name',
    'changed.name',
    'title',
    'description'
  ]
}

const createLimitedFuse = (list, options = {}) => {
  const fuse = new Fuse(list, options)

  const searchWithLimit = (pattern, maxResults, searchOptions = {}) => {
    const { _search: originalSearch } = fuse

    fuse._search = function (pattern, options) {
      const results = []

      for (let i = 0; i < this._docs.length; i++) {
        const obj = this._docs[i]
        const { matches, score } = this.matchDocument(obj, pattern, options)

        if (matches.length) {
          results.push({
            item: this._myIndex.docs[i],
            refIndex: i,
            matches,
            score
          })
        }

        if (matches.length && results.length >= maxResults) {
          break
        }
      }

      return results
    }

    const results = fuse.search(pattern, searchOptions)
    fuse._search = originalSearch
    return results
  }

  return searchWithLimit
}

/**
 * @param list
 * @param query
 * @param options
 * @param options.searchIndex
 * @param options.searchOptions
 * @param options.searchOptions.limit
 * @returns {unknown[]}
 */
function performSearchUtil (list, query, options = {}) {
  const { searchOptions, searchIndex, ...rest } = options
  const optionsToPass = {
    ...defaultOptions,
    ...rest
  }

  const fuse = new Fuse(compactArrayUtil(list), optionsToPass, searchIndex)
  if (searchOptions?.limit) {
    const searchWithLimit = createLimitedFuse(list, optionsToPass)
    return searchWithLimit(query, searchOptions.limit, searchOptions).map(searchItem => searchItem.item)
  }

  return fuse.search(query, searchOptions).map(searchItem => searchItem.item)
}

export default performSearchUtil
